import PropTypes from 'prop-types';
import Modal from '../../../../components/Modal';
import { useGetRecentGradesMutation } from '../../../../features/authentication/assessmentApiSlice';
import { useEffect, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTimes } from '@fortawesome/pro-solid-svg-icons';
import TableSkeleton from '../../../../components/SkeletonLoader/TableSkeleton';
import { DateFormatter } from '../../../../utils/DateFormatter';
import ConfirmationModal from '../../../../components/ConfirmationPopUp';

const RecentScoreModal = (
  {
    isOpen,
    onClose,
    questionId,
    courseId,
    assessmentId,
    grader,
    setIsEditMode,
    setCurrentSession,
    setScore,
    revokeGrade
  }) => {
  const [getRecentGrades] = useGetRecentGradesMutation();
  const [isLoading, setIsLoading] = useState(false);
  const [confirmModel, setConfirmModel] = useState(false);
  const [recentGrades, setRecentGrades] = useState([]);
  const [selectedSessionId, setSelectedSessionId] = useState(-1);

  useEffect(() => {
    getRecentGradesAsync();
  }, []);

  const getRecentGradesAsync = async () => {
    setIsLoading(true);
    const option = {
      questionId: questionId,
      courseId: courseId,
      assessmentId: assessmentId
    };
    var response = await getRecentGrades(option).unwrap();
    setRecentGrades(response);
    setIsLoading(false);
  };

  return (
    <>
      <Modal
        contentWidth="40%"
        isOpen={isOpen}
        onClose={onClose}
        titleName='Recent Scores'
      >
        <div className="reportBox">
          <div className='d-flex justify-content-between'>
            <div>Question:<label className='fw-semibold'>{`#${questionId}`}</label></div>
            <div>Grader: <label className='fw-semibold'>{grader}</label></div>
          </div>
        </div>
        {isLoading ? (
          <div className='mt-4'>
            <TableSkeleton
              rowCount={3}
              colCount={3}
              skeletonClass='p-1'
            />
          </div>
        ) : (
          <>
            {recentGrades.length > 0 ? (
              <table className='table reportTable mt-5'>
                <thead className='thead-light align-middle'>
                  <tr>
                    <th scope="col" className='cursor-pointer fw-medium'>
                      <span className='d-flex justify-content-center'>
                        <span className='align-items-center d-flex gap-2 justify-content-between'>Score</span>
                      </span>
                    </th>
                    <th scope="col" className='cursor-pointer fw-medium'>
                      <span className='d-flex justify-content-center'>
                        <span className='align-items-center d-flex gap-2 justify-content-between'>Date</span>
                      </span>
                    </th>
                    <th scope="col" className='cursor-pointer fw-medium'>
                      <span className='d-flex justify-content-center'>
                        <span className='align-items-center d-flex gap-2 justify-content-between'></span>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {recentGrades.map((grade, index) => (
                    <tr key={index}>
                      <td className='text-center'>
                        {grade.score}
                      </td>
                      <td className='text-center'>
                        {DateFormatter.toLongDateTime(grade.gradedDate)}
                      </td>
                      <td className='text-center'>
                        <div className='d-flex justify-content-center align-items-center gap-2'>
                          <OverlayTrigger
                            key={`editGrade${index}`}
                            placement="top"
                            overlay={<Tooltip className="custom-tooltip">Edit</Tooltip>}>
                            <button
                              id={'edit' + index}
                              className='btn grid-icon-btn info-icon-btn'
                              onClick={() => { setCurrentSession(grade); setScore(grade.score); setIsEditMode(true); onClose(false); }}
                            >
                              <FontAwesomeIcon icon={faEdit} />
                            </button>
                          </OverlayTrigger>
                          <OverlayTrigger
                            key={`unScore${index}`}
                            placement="top"
                            overlay={<Tooltip className="custom-tooltip">Remove</Tooltip>}>
                            <div>
                              <button
                                id={'unscore' + index}
                                className='btn grid-icon-btn info-icon-btn'
                                onClick={()=> {setSelectedSessionId(grade.sessionId); setConfirmModel(true);}}
                              >
                                <FontAwesomeIcon className='text-danger' icon={faTimes} />
                              </button>
                            </div>
                          </OverlayTrigger>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className='mt-5'>You have not graded this question today.</div>
            )}
          </>
        )}
        <div className='text-end mt-5'>
          <button className='btn btn-width btn-castleRed' disabled={isLoading} onClick={() => onClose(false)}>OK</button>
        </div>
      </Modal>
      {confirmModel &&
      <ConfirmationModal
        isOpen={confirmModel}
        onClose={() => setConfirmModel(false)}
        onSave={() => {revokeGrade(selectedSessionId); setConfirmModel(false); onClose(false);}}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={'Removing this score cannot be undone! <br/> Are you sure that you want to continue ?'}
        cancelButton={'No'}
        confirmButton={'Yes'}
      />
      }
    </>
  );
};

RecentScoreModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  questionId: PropTypes.number,
  courseId: PropTypes.number,
  assessmentId: PropTypes.number,
  grader: PropTypes.string,
  setIsEditMode: PropTypes.func,
  setCurrentSession: PropTypes.func,
  setScore:  PropTypes.func,
  revokeGrade: PropTypes.func
};

export default RecentScoreModal;
